/* eslint-disable no-underscore-dangle */

const _require = require('../lib/evaluateSource'),
  evaluateSource = _require.evaluateSource;

/**
  * @function evalute - evaluate reportOptionsBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const jobID = await evaluateSource(source.jobID, content, parentContentPath, transientContext, nativeFunctions);
  const reportTypeIdentifiers = await evaluateSource(source.reportTypeIdentifiers, content, parentContentPath, transientContext, nativeFunctions);
  const ifContent = await evaluateSource(source.ifContent, content, parentContentPath, transientContext, nativeFunctions);
  const hasChildren = await evaluateSource(source.hasChildren, content, parentContentPath, transientContext, nativeFunctions);
  const reportID = content.id;
  const querySource = {
    type: 'queryEntityBehavior',
    entityName: 'Report',
    properties: ['reportType/name', 'reportNumber'],
    contains: {
      'reportType/name': {
        type: 'getTransientContextBehavior',
        path: 'filterText'
      }
    },
    equals: {
      'job/id': jobID
    },
    equalsOneOf: {
      'reportType/identifier': reportTypeIdentifiers
    },
    doesNotEqual: {
      id: reportID
    },
    ifContent
  };
  const reports = await evaluateSource(querySource, content, parentContentPath, transientContext, nativeFunctions);
  const result = {};
  reports.forEach(report => {
    const fullName = "".concat(report.reportType.name, " ").concat(report.reportNumber);
    result[report.id] = {
      entity: 'Report',
      title: fullName,
      _created: fullName
    };
    if (hasChildren !== undefined) {
      result[report.id].hasChildren = hasChildren;
    }
  });
  return result;
};
module.exports = {
  evaluate
};